window.addEventListener('DOMContentLoaded', function () {
  var stickyATC = document.querySelector('#lumin-sticky-atc');
  if (!stickyATC) return;

  /* ---------- Sticky tonen/verbergen bij scrollen (ongewijzigd gedrag) ---------- */
  var mainAddBtn = document.querySelector('button[name="add"]');
  var threshold = (mainAddBtn ? mainAddBtn.getBoundingClientRect().bottom : 0) + Number(stickyATC.dataset.offset || 0);

  window.addEventListener('scroll', function () {
    if (window.scrollY > threshold) {
      stickyATC.classList.add('show');
      document.documentElement.style.paddingBottom = stickyATC.clientHeight + 'px';
      document.documentElement.style.height = 'auto';
    } else {
      stickyATC.classList.remove('show');
      document.documentElement.style.paddingBottom = '0';
    }
  });
});

/* =====================================================================
   FIX: maatkeuze in de sticky add-to-cart moet ook echt in de cart komen
   - Werkt via event delegation, zodat het blijft werken nadat het thema
     de sticky dropdowns opnieuw rendert bij een variantwissel.
   - Zet de varianten op de productpagina goed (radio's of dropdowns).
   - Zet vlak voor het toevoegen de variant-ID van het formulier op de
     variant die in de sticky is gekozen.
   ===================================================================== */
(function () {
  var STICKY = '#lumin-sticky-atc';
  var STICKY_SELECT = STICKY + ' select.sticky-atc-variant-select';

  function getPicker() {
    return document.querySelector('variant-radios, variant-selects');
  }

  function getVariants() {
    var picker = getPicker();
    var script = picker && picker.querySelector('script[type="application/json"]');
    if (!script) return [];
    try { return JSON.parse(script.textContent); } catch (e) { return []; }
  }

  function getMainForm(btn) {
    var formId = btn && btn.getAttribute('form');
    var form = formId ? document.getElementById(formId) : null;
    if (form) return form;
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].closest(STICKY)) return forms[i];
    }
    return null;
  }

  function getActiveStickySelect() {
    var selects = document.querySelectorAll(STICKY_SELECT);
    for (var i = 0; i < selects.length; i++) {
      if (selects[i].offsetParent !== null) return selects[i];
    }
    return selects[0] || null;
  }

  function setFormVariant(form, variantId) {
    if (!form || !variantId) return;
    form.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
  }

  function syncPickerToVariant(variant) {
    var picker = getPicker();
    if (!picker || !variant || !variant.options) return;

    var fieldsets = picker.querySelectorAll('fieldset');
    var selects = picker.querySelectorAll('select');
    var changed = null;

    variant.options.forEach(function (value, index) {
      var fieldset = fieldsets[index];
      if (fieldset) {
        var radios = fieldset.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === value) {
            if (!radios[i].checked) {
              radios[i].checked = true;
              changed = radios[i];
            }
            return;
          }
        }
      }
      var select = selects[index];
      if (select && select.value !== value) {
        select.value = value;
        changed = select;
      }
    });

    /* Een change-event nadat alle opties goed staan, zodat het thema
       direct de juiste combinatie (bv. kleur + maat) oppakt. */
    if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Sticky dropdown gewijzigd -> productpagina + formulier bijwerken */
  document.addEventListener('change', function (e) {
    var select = e.target && e.target.closest ? e.target.closest(STICKY_SELECT) : null;
    if (!select) return;

    var variantId = select.value;
    document.querySelectorAll(STICKY_SELECT).forEach(function (s) {
      if (s !== select && s.value !== variantId) s.value = variantId;
    });

    var stickyBtn = document.querySelector(STICKY + ' button[name="add"]');
    setFormVariant(getMainForm(stickyBtn), variantId);

    var variant = getVariants().find(function (v) { return String(v.id) === String(variantId); });
    if (variant) syncPickerToVariant(variant);
  });

  /* Vangnet: vlak voor het toevoegen via de sticky knop altijd de
     variant uit de sticky dropdown gebruiken */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(STICKY + ' button[name="add"]') : null;
    if (!btn) return;
    var select = getActiveStickySelect();
    if (!select || !select.value) return;
    setFormVariant(getMainForm(btn), select.value);
  }, true);
})();
